module.exports = __webpack_public_path__ + "img/close.8d4d5bc9.svg";